import {defaultService} from "../../services";
import {alertActions} from "../alert/alert.actions";
import {errorMessages} from "../../messages";
import {certmngConstants, uriConstants} from "../../constants";

export const certmngActions = {
  readCertmngList,
  selectCertmngInfo,
  changeSearchInfo,
  getCertmngInfo,
  settingHistory,
}

/*******************
 method 반드시 이렇게..

 GET    = Read
 POST   = Create
 PUT    = Update
 DELETE = Delete
 ********************/

/*********
 증명서 신청 목록 검색조건 변경
 **********/
function changeSearchInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: certmngConstants.SELECT_SEARCH_REQUEST,
      payload: info
    }
  }
}


/*********
 증명서 신청 목록 조회
 **********/

function readCertmngList(params) {
  return async dispatch => {
    dispatch(request())

    const queryString = require('query-string');
    let paramStr = queryString.stringify(params);
    paramStr.length > 0 && ( paramStr = "?" + paramStr )

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_CERTMNG_LIST + paramStr
    })
      .then(
        response => {
          dispatch(success(response))
        },
        error => {
          dispatch(failure(error))
          dispatch(alertActions.error({
            title: null,
            message: errorMessages.systemError
          }))
        }
      )
  }

  function request() {
    return {
      type: certmngConstants.CERTMNG_REQUEST
    }
  }
  function success(response) {
    return {
      type: certmngConstants.CERTMNG_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certmngConstants.CERTMNG_FAILURE,
      response
    }
  }
}

/***********
 증명서 신청 상세 선택
 ************/
function selectCertmngInfo(info) {
  return async dispatch => {
    dispatch(request(info))
  }
  function request(info) {
    return {
      type: certmngConstants.SELECT_REQUEST,
      payload: info
    }
  }
}

/*********
 증명서 신청 상세조회
 **********/

function getCertmngInfo(crtfCd) {
  return async dispatch => {
    dispatch(request())

    defaultService.handleService({
      method: 'get',
      endPoint: uriConstants.API_URI + uriConstants.GET_CERTMNG_INFO + "/" + crtfCd
    })
        .then(
            response => {
              dispatch(success(response))
            },
            error => {
              dispatch(failure(error))
              dispatch(apiError(error))
            }
        )
  }

  function request() {
    return {
      type: certmngConstants.DETAIL_REQUEST
    }
  }
  function success(response) {
    return {
      type: certmngConstants.DETAIL_SUCCESS,
      response
    }
  }
  function failure(response) {
    return {
      type: certmngConstants.DETAIL_FAILURE,
      response
    }
  }
}

/***********
 증명서 신청 히스토리관리
 ************/
function settingHistory(history) {
  return async dispatch => {
    dispatch(request(history))
  }

  function request(history) {
    return {
      type: certmngConstants.CERTMNG_HISTORY,
      payload: history
    }
  }
}

function apiError(error) {
  return alertActions.error({
    title: null,
    message: error.response?.data?.errors?.message ? error.response.data.errors.message : errorMessages.systemError
  })
}

